<template>
  <div
    v-if="showSettings || showDelete || showUsers"
    class="dropdown"
  >
    <button
      class="btn"
      type="button"
      :ref="`dropdownMenu${id}`"
      data-bs-toggle="dropdown"
      @click="dropdown.toggle()"
      aria-expanded="false"
      style="padding: 0 !important"
    >
      <font-awesome-icon :icon="['far', 'ellipsis-h']" color="grey" />
    </button>
    <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="dropdownMenuButton">
      <li v-if="showSettings">
        <span class="dropdown-item cpt" @click="$emit('settings', id)">
          {{ $t('settings.settings') }}
        </span>
      </li>
      <li v-if="showDelete">
        <span class="dropdown-item cpt" @click="$emit('delete', id)">
          {{ $t('settings.delete') }}
        </span>
      </li>
      <li v-if="showUsers">
        <span class="dropdown-item cpt" @click="$emit('users', id)">
          {{ $t('settings.user') }}
        </span>
      </li>
    </ul>
  </div>
</template>

<script>
  import {Dropdown} from "@comlinedev/bootstrap5";

  export default {
    name: "DropDownTools",
    props: {
      id: {
        type: String,
        required: true,
      },
      showSettings: {
        type: Boolean,
        default: false,
      },
      showDelete: {
        type: Boolean,
        default: false,
      },
      showUsers: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        dropdown: null,
      };
    },
    mounted() {
      this.dropdown = new Dropdown(this.$refs[`dropdownMenu${this.id}`]);
    },
  };
</script>
